/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-dupe-keys */
import React from 'react';
import qs from 'query-string';
//import $ from 'jquery';
import moment from 'moment';
import ConfirmDialog from './ConfirmDialog';
//import TransacaoDetalhes from './TransacaoDetalhes';
import DatePicker from 'react-datepicker';
import InputMask from 'react-input-mask';
import { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import api from '../../../services/api';
registerLocale('pt-BR', ptBR);

class Relatorio extends React.Component {
	constructor(props) {
		super(props);
		this.confirmDialog = React.createRef();

		let now = moment().format('DD/MM/YYYY');
		let qparams = Object.assign(
			{
				q: '',
				data_inicial: moment().toDate(),
				data_final: moment().toDate(),
				pontovenda: '',
				tipo: '',
				status: '',
				data_inicial: now,
				data_final: now,
			},
			qs.parse(this.props.location.search)
		);

		this.getTransacoes(qparams);
		if (Object.keys(qparams).length) {
			if (qparams.data_inicial) {
				qparams.data_inicial = moment(
					qparams.data_inicial,
					'DD/MM/YYYY'
				).toDate();
			}
			if (qparams.data_final) {
				qparams.data_final = moment(qparams.data_final, 'DD/MM/YYYY').toDate();
			}
		}

		this.state = {
			pontovendas: [],
			transacoes: [],
			params: qparams,
		};

		this.getPontoVendasOption();
		this.handleInput = this.handleInput.bind(this);
		this.handleDatepicker = this.handleDatepicker.bind(this);
		this.confirm = this.confirm.bind(this);
	}

	async getTransacoes(params) {
		var self = this;
		const { data, status } = await api.get('/admin/transacao/json', params);
		if (status === 200) {
			self.setState({ transacoes: data });
		}
	}

	async getPontoVendasOption() {
		var self = this;
		const { data, status } = await api.get('/admin/pontovenda/json');
		if (status === 200) {
			self.setState({ pontovendas: data });
		}
	}

	handleDatepicker(name, value) {
		var params = this.state.params;
		params[name] = value;
		this.setState({
			params: params,
		});
	}

	handleInput(e) {
		var target = e.target;
		var name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		var params = this.state.params;
		params[name] = value;
		this.setState({
			params: params,
		});
	}

	confirm(event) {
		this.confirmDialog.current.setUrl(event.target.getAttribute('data-href'));
		event.preventDefault();
		return false;
	}

	render() {
		const statuses = {
			0: 'Processando',
			1: 'Paga',
			2: 'Cancelada',
			3: 'Falhada',
		};
		const colors = {
			0: 'dark',
			1: 'success',
			2: 'danger',
			3: 'danger',
		};
		const { pontovendas, transacoes, params } = this.state;
		let qparams = Object.assign({}, params);

		if (qparams.data_inicial) {
			qparams.data_inicial = moment(qparams.data_inicial, 'DD/MM/YYYY').format(
				'DD/MM/YYYY'
			);
		}
		if (qparams.data_final) {
			qparams.data_final = moment(qparams.data_final, 'DD/MM/YYYY').format(
				'DD/MM/YYYY'
			);
		}

		////console.log(qparams);

		return (
			<div className='Relatorio row'>
				<div className='col-md-12 header-page p-3'>
					<h2 className='title'>
						Relatório de Pagamentos
						<div className='d-inline-block ml-4'>
							<div className='btn-group btn-exportar'>
								<a
									className='btn btn-sm btn-warning'
									target='__blank'
									href={
										'/admin/transacao/relatorio?' +
										qs.stringify(Object.assign({ formato: 'pdf' }, qparams))
									}>
									Exportar Relatório
								</a>
								<button
									className='btn btn-sm btn-warning dropdown-toggle'
									type='button'
									id='dropdownMenuButton'
									data-toggle='dropdown'
									aria-haspopup='true'
									aria-expanded='false'>
									<span className='sr-only'>Toggle Dropdown</span>
								</button>
								<div
									className='dropdown-menu dropdown-menu-right'
									aria-labelledby='dropdownMenuButton'>
									<a
										className='dropdown-item'
										target='__blank'
										href={
											'/admin/transacao/relatorio?' +
											qs.stringify(Object.assign({ formato: 'pdf' }, qparams))
										}>
										PDF
									</a>
									<a
										className='dropdown-item'
										target='__blank'
										href={
											'/admin/transacao/relatorio?' +
											qs.stringify(Object.assign({ formato: 'xls' }, qparams))
										}>
										XSL
									</a>
									<a
										onClick={this.confirm}
										className='dropdown-item aa'
										data-toggle='modal'
										data-target='#confirm-dialog'
										data-href={
											'/admin/transacao/arquivo-retorno?' +
											qs.stringify(Object.assign({ formato: 'ret' }, qparams))
										}>
										RETORNO
									</a>
								</div>
							</div>
						</div>
					</h2>
				</div>
				<div className='col-md-12'>
					<div className='card border-0 mt-4'>
						<div className='card-body'>
							<div className='row'>
								<div className='col-md-12'></div>
							</div>
							<div>
								<form>
									<div className='row'>
										<div className='form-group col-md-6'>
											<label>Pesquisa</label>
											<input
												className='form-control'
												type='text'
												name='q'
												onChange={this.handleInput}
												placeholder='Nome do cliente, ATK ou UC'
												value={params.q}
											/>
										</div>
										<div className='form-group col-md-3'>
											<label>Data Inicial</label>
											<br />
											<DatePicker
												className='form-control'
												name='data_inicial'
												dateFormat='dd/MM/yyyy'
												selected={params.data_inicial}
												onChange={(e) =>
													this.handleDatepicker('data_inicial', e)
												}
												locale='pt-BR'
												customInput={<InputMask mask='99/99/9999' />}
											/>
										</div>
										<div className='form-group col-md-3'>
											<label>Data Final</label>
											<br />
											<DatePicker
												className='form-control'
												name='data_final'
												dateFormat='dd/MM/yyyy'
												selected={params.data_final}
												onChange={(e) => this.handleDatepicker('data_final', e)}
												locale='pt-BR'
												customInput={<InputMask mask='99/99/9999' />}
											/>
										</div>
									</div>
									<div className='row'>
										<div className='form-group col-md-3'>
											<label>PontoVenda</label>
											<select
												className='form-control input-sm'
												name='pontovenda'
												value={params.pontovenda}
												onChange={this.handleInput}>
												<option value=''>Todos</option>
												{pontovendas.map((maq) => (
													<option key={maq.id} value={maq.id}>
														{maq.apelido}{' '}
														{maq.localidade
															? ' - (' + maq.localidade + ')'
															: ''}
													</option>
												))}
											</select>
										</div>
										<div className='form-group col-md-3'>
											<label>Tipo</label>
											<select
												className='form-control input-sm'
												name='tipo'
												value={params.tipo}
												onChange={this.handleInput}>
												<option value=''>Todos</option>
												<option value='1'>Débito</option>
												<option value='2'>Crédito</option>
											</select>
										</div>
										<div className='form-group col-md-3'>
											<label>Situação</label>
											<select
												className='form-control input-sm'
												name='status'
												value={params.status}
												onChange={this.handleInput}>
												<option value=''>Todos</option>
												<option value='0'>Processando</option>
												<option value='1'>Pago</option>
												<option value='2'>Cancelado</option>
												<option value='3'>Falha</option>
											</select>
										</div>
										<div className='form-group col-md-3'>
											<br />
											<button className='mt-2 btn btn-block btn-primary'>
												Filtrar
											</button>
										</div>
									</div>
								</form>
							</div>
							<div>
								<table className='table'>
									<thead>
										<tr>
											<th>Origem/Status</th>
											<th>Data</th>
											<th>Cliente</th>
											<th>Valor</th>
											<th>Vencimento</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										{transacoes.map((transacao) => (
											<tr key={transacao.id}>
												<td>
													<span>
														{/* {transacao.pontovenda.apelido}
                                                        {transacao.pontovenda.localidade ? ' (' + transacao.pontovenda.localidade + ')' : ''} */}
													</span>
													<br />
													<strong
														className={
															'text-' + colors[transacao.status] || 'dark'
														}>
														{statuses[transacao.status]}
													</strong>
												</td>
												<td>{transacao.dataCadastro}</td>
												<td>
													{transacao.nome} ({transacao.uc})
												</td>
												<td>
													R$ {transacao.fatura} (
													{transacao.parcelas == null
														? '1'
														: transacao.parcelas}
													x)
												</td>
												<td>{transacao.vencimento}</td>
												<td>
													<button
														className='btn btn-sm btn-default border'
														data-toggle='modal'
														data-target={'#modalDetalhes' + transacao.id}>
														Detalhes
													</button>
													{/* <TransacaoDetalhes elementId={'modalDetalhes' + transacao.id} transacao={transacao} /> */}
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<ConfirmDialog ref={this.confirmDialog} elementId='confirm-dialog' />
			</div>
		);
	}
}

export default Relatorio;
